import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserModuleAccessService } from '@common/services/usermoduleaccess';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { UserService } from '../user/user.service';

@Injectable({providedIn: 'root'})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userModuleAccessService: UserModuleAccessService,
        private _userSerice:UserService
        )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        var accessibleModules = [];
        this._userSerice.user$.subscribe(u=>{
            accessibleModules=u.accessibleModules;
        });
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) =>
            {
                this._userModuleAccessService.getNavigationList(navigation.default);
                var mynav = this._userModuleAccessService.getFilterNavList(navigation.default);
                navigation.default = mynav;
                this._navigation.next(navigation);
            }),
        );
    }
    
}
